<template>
  <el-drawer
    v-if="visible"
    :title="$l('dialog_title_edit_sku') || '编辑SKU'"
    :visible="visible"
    show-close
    :size="1000"
    @before-close="close"
    @close="close"
    :wrapper-closable="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="drawer-main">
      <div class="d-flex">
        <div class="pr-2">
          <el-image
            :src="formData.defaultImageUrl"
            :preview-src-list="[formData.defaultImageUrl]"
            style="width:100px; height:100px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width:100px; height:100px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex:1">
          <div class="el-descriptions">
            <div class="el-descriptions__body">
              <div
                class="el-descriptions__table is-bordered el-descriptions--small"
              >
                <div class="el-descriptions-row">
                  <div
                    class="el-descriptions-item__cell el-descriptions-item__label is-bordered-label"
                  >
                    <div class="sku_main">
                      <div>
                        <span v-if="formData.goodsName">
                          {{ formData.goodsName }}
                        </span>
                        <span v-if="formData.goodsNameEn">
                          {{ formData.goodsNameEn }}
                        </span>
                        <span v-if="formData.masterCategoryName">
                          {{ `(${formData.masterCategoryName})` }}
                        </span>
                      </div>
                      <div>
                        <span v-if="formData.amzSkuNo">
                          {{ formData.amzSkuNo }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-descriptions border size="small" class="bottom-desc" :column="3">
            <el-descriptions-item
              :label="$l('form_label_goodsName') || '中文名称'"
              :labelStyle="{ width: '110px' }"
              :contentStyle="{ width: '230px' }"
            >
              {{ formData.goodsName }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_goodsNameEn') || '英文名称'"
              :labelStyle="{ width: '110px' }"
              :contentStyle="{ width: '230px' }"
            >
              {{ formData.goodsNameEn }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_goodsColor') || '颜色'"
              :labelStyle="{ width: '110px' }"
              :contentStyle="{ width: '230px' }"
            >
              {{ formData.goodsColor }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_goodsSize') || '产品尺寸'"
              :labelStyle="{ width: '110px' }"
              :contentStyle="{ width: '230px' }"
            >
              {{ formData.goodsSize }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_masterCategoryName') || '主分类名称'"
              :labelStyle="{ width: '110px' }"
              :contentStyle="{ width: '230px' }"
            >
              {{ formData.masterCategoryName }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('INDEX.Status') || '状态'"
              :labelStyle="{ width: '110px' }"
              :contentStyle="{ width: '230px' }"
            >
              <b-badge
                style="font-size: 12px"
                :variant="
                  formData.amzFlipOrderSkuStatus == 'N'
                    ? 'info'
                    : formData.amzFlipOrderSkuStatus == 'C'
                    ? 'warning'
                    : formData.amzFlipOrderSkuStatus == 'S'
                    ? 'primary'
                    : formData.amzFlipOrderSkuStatus == 'P'
                    ? 'success'
                    : formData.amzFlipOrderSkuStatus == 'R'
                    ? 'danger'
                    : ''
                "
              >
                {{ formData.v_amzFlipOrderSkuStatus || '草稿' }}
              </b-badge>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_skuPackSize') || '售卖方式'"
              :labelStyle="{ width: '110px' }"
              :contentStyle="{ width: '230px' }"
            >
              <b-badge style="font-size: 12px" variant="info">
                {{ formData.skuPackSize }}
              </b-badge>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_inCtnQty') || '装箱入数'"
              :labelStyle="{ width: '110px' }"
              :contentStyle="{ width: '230px' }"
            >
              {{ formData.inCtnQty }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>

      <el-form
        class="mt-1"
        ref="form"
        direction="vertical"
        size="small"
        :model="formData"
        :rules="rules"
      >
        <el-row :gutter="10">
          <el-col :span="3">
            <el-form-item
              :label="$l('table_label_estimatedSales') || '补货基数'"
              prop="estimatedSales"
            >
              <el-input
                v-model="formData.estimatedSales"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                style="width: 100%"
                size="small"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('table_label_confirmedSales') || '确认补货基数'"
              prop="confirmedSales"
            >
              <el-input-number
                v-model="formData.confirmedSales"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                controls-position="right"
                style="width: 100%"
                :precision="0"
                :min="0"
                :step="1"
                size="small"
                step-strictly
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('table_label_estimatedFlipQuantity') || '预计翻单数量'"
              prop="estimatedFlipQuantity"
            >
              <el-input
                v-model="formData.estimatedFlipQuantity"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                style="width: 100%"
                size="small"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('table_label_actualFlipQuantity') || '实际翻单数量'"
              prop="actualFlipQuantity"
            >
              <el-input-number
                v-model="formData.actualFlipQuantity"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                controls-position="right"
                style="width: 100%"
                :precision="0"
                :min="0"
                :step="1"
                size="small"
                step-strictly
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="
                $l('form_label_earliestDeliveryDate') || '期望最早交货日期'
              "
              prop="earliestDeliveryDate"
            >
              <el-date-picker
                v-model="formData.earliestDeliveryDate"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="mt-2">
        <MarketTable :amzFlipOrderSkuCode="amzFlipOrderSkuCode"></MarketTable>
      </el-row>
      <div class="mt-2 d-flex" style="justify-content: end;">
        <span>
          <el-button size="small" @click="close()">
            {{ this.$l('INDEX.btn_cancel') || '取消' }}
          </el-button>
          <el-button type="primary" size="small" @click="save()">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
          <el-button type="primary" size="small" @click="saveAndSubmit()">
            {{ $l('btn_save_submit') || '保存并提交' }}
          </el-button>
        </span>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import MarketTable from './market-table.vue'
import validate from '@/libs/util.validate'

export default {
  mixins: [EditLoading],
  components: { MarketTable },
  props: {
    visible: { type: Boolean, default: false },
    amzFlipOrderSkuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        defaultImageUrl: '',
      },
      rules: {
        confirmedSales: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('INDEX.tips_confirmedSales_must_be_greater_than_0') ||
              '确认补货基数须大于0',
          },
        ],
        actualFlipQuantity: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('INDEX.tips_actualFlipQuantity_must_be_greater_than_0') ||
              '实际翻单数量须大于0',
          },
        ],
        earliestDeliveryDate: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  computed: {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$api
        .ecomAmzFlipOrderSkuDetailApi({
          amzFlipOrderSkuCode: this.amzFlipOrderSkuCode,
        })
        .then((res) => {
          this.formData = { ...res.body }
        })
    },
    async saveAndSubmit() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      this.$api
        .ecomAmzFlipOrderSkuSaveSubmitApi({ ...this.formData })
        .then((res) => {
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.loadingClose()
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      this.$api
        .ecomAmzFlipOrderSkuSaveApi({
          ...this.formData,
        })
        .then((res) => {
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.loadingClose()
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.drawer-main {
  padding: 0 30px 10px;
}
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
.sku_main {
  font-size: 13px;
  font-weight: bold;
  color: #333;
}
</style>
